import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import { ComponentProps } from "react";
import { styled } from "~/application/theme";

export type DropdownMenuTriggerProps = ComponentProps<typeof DropdownMenuTrigger>;

export const DropdownMenuTrigger = styled(DropdownMenuPrimitive.Trigger, {});
